<template>
  <BaseModal border-radius-size="small" @close="onClose">
    <ModalContainer>
      <ModalTitle>
        <slot name="title"></slot>
      </ModalTitle>

      <ModalBody>
        <slot name="body"></slot>
      </ModalBody>
      <slot></slot>

      <ModalActions v-if="$slots.actions">
        <slot name="actions"></slot>
      </ModalActions>
    </ModalContainer>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '../base/BaseModal.vue'
import ModalActions from './ModalActions.vue'
import ModalBody from './ModalBody.vue'
import ModalContainer from './ModalContainer.vue'
import ModalTitle from './ModalTitle.vue'

const emit = defineEmits(['onClose'])

const onClose = () => {
  emit('onClose')
}
</script>
